<template>
	<full-page ref="fullpage" :options="options" class="am-home" :skip-init="true">

		<div class="section">
			<am-post
				class="am-home__post"
				:init="post.init"
				:title="post.current.title"
				:slug="post.current.slug"
				:cat="post.current.category"
				:category_id="post.current.category_id"
				:text="post.current.text"
				:background="post.background"
				:image="post.current.img"
				:posts="post.posts"
			/>

		</div>

		<div class="whatsapp" @click="onClick(whatsapp)">
			<div class="whatsapp--icon"></div>
		</div>
	</full-page>
</template>

<script>
import AMHero from '@/components/organisms/AMHero'
import AMAbout from '@/components/organisms/AMAbout'
import AMEnvironment from '@/components/organisms/AMEnvironment'
import AMContact from '@/components/organisms/AMContact'
import AMSection from '@/components/organisms/AMSection'
import AMAlbum from '@/components/organisms/AMAlbum'
import AMTeam from '@/components/organisms/AMTeam'
import AMPromote from '@/components/organisms/AMPromote'
import AMLocation from '@/components/organisms/AMLocation'
import AMTimeline from '@/components/organisms/AMTimeline'
import AMPost from '@/components/organisms/AMPost'

export default {
	components: {
		'am-post': AMPost
	},

	props: {
		current: {
			type: String,
			default: 'blog'
		},
		anchors: {
			type: Array,
			default: () => (['blog'])
		},

		post: {
			type: Object,
			default: () => ({})
		},

	},

	data: vm => ({
		fullpage: null,
		options: {
			anchors: vm.anchors,
			scrollBar: false,
			fitToSection: false,
			dragAndMove: 'vertical',
			// scrollingSpeed: 500,
			scrollOverflow: true,
			paddingTop: '60px',
			touchSensitivity: 20,
			normalScrollElementTouchThreshold: 50,
			afterLoad: function(origin, destination, direction) {
				vm.$store.commit('navigation/setCurrent', destination.anchor)
			}
		}
	}),

	watch: {
		current(value) {
			if (this.fullpage)
				this.fullpage.moveTo(value)
		}
	},

	componentsReady() {
    this.fullpage.init();
  },

	mounted() {
		this.fullpage = this.$refs.fullpage.api;
	}
}
</script>

<style lang="scss">
/* 
	body{
		overflow: auto !important;
	} 
*/
.am-home{
	&__hero,
	&__about,
	&__section,
	&__album,
	&__environment,
	&__team,
	&__promote,
	&__location,
	&__timeline,
	&__blog,
	&__post,
	&__contact{
		height: 100%;
		clear: both;
	}

	@include grid-media($desktop-grid) {
		&__footer{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
		}
	}
}
</style>
